import {Component, Input, EventEmitter, OnChanges, Output} from '@angular/core';
import { ConfigApiService } from '../../../../../../projects/api/src/config/config-api.service';
import {environment} from '../../../../../environments/environment';

@Component({
    selector: 'app-about-app',
    templateUrl: './about-app.component.html',
    styleUrls: ['./about-app.component.scss'],
    standalone: false
})
export class AboutAppComponent implements OnChanges {

  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public coreVersion: string;
  public webVersion: string;

  constructor(private configApiService: ConfigApiService) {}

  ngOnChanges() {
    if (this.visible && !this.coreVersion) {
      this.loadVersion();
    }
  }

  loadVersion() {
    this.configApiService.getVersion().subscribe(version => {
      this.coreVersion = version;
      this.webVersion = environment.version;
    });
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
